import { render, staticRenderFns } from "./MemberLogs.vue?vue&type=template&id=428c36c0&"
import script from "./MemberLogs.vue?vue&type=script&lang=js&"
export * from "./MemberLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports